import * as THREE from 'three';
import { Weapon, WeaponConfig } from './Weapon';
import { Bullet } from '../entities/Bullet';

export class CannonWeapon extends Weapon {
  constructor() {
    const config: WeaponConfig = {
      name: '主炮',
      type: 'cannon',
      damage: 34,
      cooldown: 0.5,
      ammo: -1, // Unlimited
      maxAmmo: -1,
      projectileSpeed: 30,
      range: 50
    };
    super(config);
  }

  createProjectile(
    position: THREE.Vector3,
    direction: THREE.Vector3,
    owner: 'player' | 'enemy'
  ): Bullet {
    return new Bullet(position, direction, owner);
  }
}
